import { render, staticRenderFns } from "./CbsCtrlObject.vue?vue&type=template&id=efb363c6&scoped=true"
import script from "./CbsCtrlObject.vue?vue&type=script&lang=js"
export * from "./CbsCtrlObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb363c6",
  null
  
)

export default component.exports